// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://wdtfntttqrnkzacedzli.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndkdGZudHR0cXJua3phY2VkemxpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU4MTMwNDQsImV4cCI6MjA2MTM4OTA0NH0.g5WaSpJHpYG33xtFtHpcsNSkdI2ntMA79rmo4UlUslg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);